function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreaLot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "26.46 7.41 26.46 22.13 21.26 22.13 21.26 25.59 6.54 25.59 6.54 7.41 26.46 7.41",
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 4,
    x2: 28,
    y2: 4,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 27,
    x2: 3,
    y2: 6,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 4,
    x2: 28,
    y2: 2,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 4,
    x2: 5,
    y2: 2,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 2,
    y2: 6,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 27,
    x2: 2,
    y2: 27,
    style: {
      fill: "none",
      stroke: "#69757c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.98,20v-3.53c0-.44-.22-.78-.77-.78-.5,0-.86,.32-1.04,.56v3.74h-1.85v-3.53c0-.44-.2-.78-.77-.78-.49,0-.84,.32-1.03,.56v3.74h-1.85v-5.79h1.85v.71c.25-.34,1-.85,1.91-.85,.83,0,1.4,.35,1.64,1.03,.34-.5,1.09-1.03,2-1.03,1.07,0,1.74,.55,1.74,1.74v4.2h-1.83Z",
    style: {
      fill: "#69757c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25,14v-.94c1.83-1.29,2-1.44,2-1.74,0-.19-.2-.31-.49-.31-.4,0-.73,.16-1.03,.41l-.66-.8c.46-.49,1.13-.68,1.69-.68,1.04,0,1.71,.58,1.71,1.38,0,.55-.31,1-1.39,1.62h1.42v1.06h-3.27Z",
    style: {
      fill: "#69757c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaLot);
export default __webpack_public_path__ + "static/media/area_lot.bbad79f51e6bfbbb3ee289c918481be3.svg";
export { ForwardRef as ReactComponent };